
document.addEventListener('DOMContentLoaded', function () {

  function getSelectedRapiPack() {
    const checkedInput = document.querySelector(
      '.rapi-bundles__bars .rapi-bundles__bar input[type="radio"]:checked'
    );

    if (!checkedInput) return '';

    const selectedBar = checkedInput.closest('.rapi-bundles__bar');
    if (!selectedBar) return '';

    const title = selectedBar.querySelector('.rapi-bundles__bar-title');
    if (!title) return '';

    return title.textContent.trim();
  }

  function updateSelectedPackProperty() {
    const selectedPack = getSelectedRapiPack();

    document.querySelectorAll('.selected-pack-property').forEach(function (input) {
      input.value = selectedPack;
      input.setAttribute('value', selectedPack);
    });

    console.log('Selected pack set:', selectedPack);
  }

  updateSelectedPackProperty();

  document.addEventListener('click', function (event) {
    if (event.target.closest('.rapi-bundles__bar')) {
      setTimeout(updateSelectedPackProperty, 100);
      setTimeout(updateSelectedPackProperty, 500);
      setTimeout(updateSelectedPackProperty, 1000);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('.rapi-bundles__bar input[type="radio"]')) {
      updateSelectedPackProperty();
    }
  });

});
